"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GLOBAL_CSS_CLASSES = {
    fixedWindow: "fixed-window",
    siteNavOpen: "site-nav-open"
};
